export default {"src":"/_next/static/media/arrow_right_white.a6c0371e.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};